import React from 'react';
import { Link } from 'react-router-dom';
import { FolderOpenFilled, PictureFilled } from '@ant-design/icons';

const NoMaterialContent = props => {
	const { iconType, from, eventID } = props;
	const icon = iconType === 'library' ? <FolderOpenFilled /> : <PictureFilled />;
	const text = iconType === 'library' ? 'There are no materials yet' : 'No media';
	return (
		<div className={'NoContent'}>
			<div className={'no-content-icon'}>{icon}</div>
			<p className={'no-content-header'}>{text}</p>
			<p className={'no-content-subheader'}>
				Upload an image, video, or PDF file{' '}
				{from ? (
					<Link
						to={{
							pathname: `/events/${eventID}/materials`,
						}}
					>
						in Attendee Materials{' '}
					</Link>
				) : null}
				to get started
			</p>
		</div>
	);
};

export default NoMaterialContent;
